import {NotificationFactory} from "../../Components/Notifications/NotificationFactory/NotificationFactory";
import {api as config} from "../../SiteConfig/siteConstants";
import {serialize} from "object-to-formdata";
import {ajaxBlobRequest} from "./Requests/ajaxBlobRequest";
import {ajaxRequestWithRetry} from "./Requests/ajaxRequestWithRetry";
import type {AjaxRequestOptions} from "./Requests/ajaxRequestOptions";

const notificationFactory = new NotificationFactory();
const isAuthorizedUrl = config.URL + "accounts/is-authorized";

function validateOptions(ajaxRequestOptions: AjaxRequestOptions): void {
    if (!ajaxRequestOptions) throw new Error("Requests options are required to configure the http request.");
}

export function sendRequest(ajaxRequestOptions: AjaxRequestOptions): Promise<unknown> {
    validateOptions(ajaxRequestOptions);

    return ajaxRequestWithRetry(notificationFactory, isAuthorizedUrl).send(ajaxRequestOptions);
}

export function downloadBlob(ajaxRequestOptions: AjaxRequestOptions): Promise<Blob | undefined> {
    validateOptions(ajaxRequestOptions);

    return ajaxBlobRequest(notificationFactory).send(
        ajaxRequestOptions,
    );
}

function mockApiCall(message: string | null, resolveResult?: unknown): Promise<unknown> {
    return new Promise((resolve, reject) => {
        if (resolveResult) {
            if (message) {
                notificationFactory.createSuccess(message).notify();
            }
            resolve(resolveResult);
        } else {
            const errorString = message ? message : "No result given to test.";
            notificationFactory.createError(errorString).notify();
            reject(errorString);
        }
    });
}

export function mockResolveApiCall(result: unknown, successMessage: string = ""): Promise<unknown> {
    return mockApiCall(successMessage, result);
}

export function mockRejectApiCall(errorMessage: string): Promise<unknown> {
    return mockApiCall(errorMessage);
}

export function convertObjectToFormData(obj: Record<string, unknown>, fileData?: FormData): FormData {
    return serialize(obj, {indices: true}, fileData);
}
